var contactFormInputs = document.querySelectorAll('.wpcf7-form-control'); // or your custom input class
contactFormInputs.forEach(function(element) {
    element.addEventListener('focus', function(event) {
        event.target.parentElement.classList.add("focused");
    });
    element.addEventListener('blur', function(event) {
        event.target.parentElement.classList.remove("focused");
    });
    element.addEventListener('change', function(event) {
        event.target.value
            ? event.target.parentElement.classList.add("valid")
            : event.target.parentElement.classList.remove("valid")
    }); 
});